import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a21e3ee8&"
import script from "./App.ts?vue&type=script&lang=ts&"
export * from "./App.ts?vue&type=script&lang=ts&"
import style0 from "./App.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
